import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { arcPresence } from '../../helpers/arcPresence/arcPresenceStore'
import { useArcNavigationRequest, useIsArcWorking } from '../../hooks/useArcPresence'
import ArcActivityRail from './ArcActivityRail'
import styles from './ArcPresence.module.scss'

/**
 * Arc's presence over the whole app: a line of light along the top while it
 * works on something of yours, a rail of what it is doing where you aren't
 * looking, and the pages it opens for you. Rows Arc touches on screen show it
 * themselves.
 */
const ArcPresenceLayer = () => {
  const isWorking = useIsArcWorking()
  const navigation = useArcNavigationRequest()
  const navigate = useNavigate()

  // Arc asked to take them somewhere; the call and its pill ride along, above the pages.
  useEffect(() => {
    if (!navigation) return
    arcPresence.completeNavigation(navigation.id)
    void navigate(navigation.url)
  }, [navigation, navigate])
  return (
    <>
      {isWorking && <div className={styles.ambient} aria-hidden />}
      <ArcActivityRail />
    </>
  )
}

export default ArcPresenceLayer
